import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import TemuStockListPage from '@/temu-platform/modules/ops/TemuStockListPage';
import { normalizeTemuShopTypeSlug } from '@/temu-platform/constants/temuRoutes';

export default function TemuStockRoutePage() {
  const { t } = useTranslation('workbench');
  const { shopType } = useParams();
  const track = normalizeTemuShopTypeSlug(shopType) || 'semi';
  const isFull = track === 'full';
  return (
    <TemuStockListPage
      track={track}
      title={isFull ? t('stock.jitTitle') : t('platformNav.stock')}
    />
  );
}
